import type { ReactNode, SVGProps } from "react";

export function LockIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.5"
			viewBox="0 0 16 16"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect height="7" rx="1.5" width="10" x="3" y="7" />
			<path d="M5.5 7V4.75a2.5 2.5 0 0 1 5 0V7" />
		</svg>
	);
}
